import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { StaticUrls, EmailTemplate } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { MyCookieService } from './my-cookie.service';
import { environment } from 'environments/environment';

@Injectable()
export class EmailTemplateService {
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp,
		@Inject(MyCookieService) private myCookieService: MyCookieService,
		private router: Router) { }

	get(idTipologia: number): Observable<EmailTemplate> {
		if(this.myCookieService.token){
			if (this.ifTokenNotExpired()) {
				return this.http.get(StaticUrls._getEmailTemplate(idTipologia), this.options)
					.map(this.extractDataObj)
					.catch(this.handleError);
			}
		}
	}

	private extractDataObj(res: Response) {
		return res.json();
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}

	private ifTokenNotExpired() {
		if(this.myCookieService.token){
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/email-template.service.ts